export const breakpoints = {
  '2xl': '1536px',
  xl: "1127px",
  lg: "933px",
  md: "723px",
  sm: "320px"
}